var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.5 4.5h15A2.5 2.5 0 0 1 22 7v2.1a2.9 2.9 0 0 0 0 5.8V17a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 17v-2.1a2.9 2.9 0 0 0 0-5.8V7a2.5 2.5 0 0 1 2.5-2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5131A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.8 2.4",
    d: "M12 6.7v10.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTicket);
export default __webpack_public_path__ + "static/media/ic_ticket.cd0fb125b64b14be70dec84d961517ec.svg";
export { ForwardRef as ReactComponent };